<template>
  <div class="app-main-container">

    <Loader/>

    <div class="logo-bar">
      <img src="/img/logo.png" alt="Al-Abtaal Logo" class="first-logo"/>

      <AdvancedImage
          v-if="tenantCloudinaryImage"
          :cldImg="tenantCloudinaryImage"
          class="second-logo"
          @error="$event.target.src = defaultLogo; $event.target.onerror = null;"
      />
      <img v-else :src="defaultLogo" alt="Default Tenant Logo" class="second-logo"/>
    </div>

    <div class="app-layout">
      <div
          class="sidebar-overlay"
          v-if="isSidebarOpen && !isLoginPage"
          @click="toggleSidebar">
      </div>

      <aside class="sidebar" :class="{ 'sidebar-open': isSidebarOpen }" v-if="!isLoginPage">
        <div class="sidebar-brand">
          <router-link to="/" class="brand-link" @click="closeSidebarMobile">
            <div class="brand-icon">
              <i class="bi bi-hexagon-fill"></i>
            </div>
            <span class="brand-text">Dashboard</span>
          </router-link>
        </div>

      <div class="sidebar-menu">
        <p class="menu-label">CATALOG</p>
        <router-link to="/items" class="menu-item" active-class="active" @click="closeSidebarMobile">
          <i class="bi bi-box-seam"></i>
          <span>Items</span>
        </router-link>
        <router-link to="/Stores" class="menu-item" active-class="active" @click="closeSidebarMobile">
          <i class="bi bi-shop"></i>
          <span>Stores</span>
        </router-link>

        <p class="menu-label mt-3">OPERATIONS</p>
        <router-link to="/item-adjustments" class="menu-item" active-class="active" @click="closeSidebarMobile">
          <i class="bi bi-sliders"></i>
          <span>Item Adjustment</span>
        </router-link>
        <router-link to="/item-recipes" class="menu-item" active-class="active" @click="closeSidebarMobile">
          <i class="bi bi-journal-text"></i>
          <span>Item Recipe</span>
        </router-link>

        <p class="menu-label mt-3">TRANSACTIONS</p>
        <div class="menu-group">
          <a class="menu-item has-submenu" @click.prevent="toggleSubmenu('itemTrans')" :class="{ 'submenu-open': openSubmenus.includes('itemTrans') }">
            <i class="bi bi-arrow-left-right"></i>
            <span>Item Trans</span>
            <i class="bi bi-chevron-down submenu-indicator"></i>
          </a>
          <div class="submenu" v-show="openSubmenus.includes('itemTrans')">
            <router-link to="/raw-material-receive" class="submenu-item" active-class="active" @click="closeSidebarMobile">Raw Material Receipt</router-link>
            <router-link to="/issuance" class="submenu-item" active-class="active" @click="closeSidebarMobile">Issue</router-link>
            <router-link to="/processing" class="submenu-item" active-class="active" @click="closeSidebarMobile">Processing</router-link>
            <router-link to="/finish-good-receive" class="submenu-item" active-class="active" @click="closeSidebarMobile">Finish Good Receipt</router-link>
          </div>
        </div>

        <p class="menu-label mt-3">REPORTS</p>
        <div class="menu-group">
          <a class="menu-item has-submenu" @click.prevent="toggleSubmenu('reports')" :class="{ 'submenu-open': openSubmenus.includes('reports') }">
            <i class="bi bi-graph-up"></i>
            <span>Reports</span>
            <i class="bi bi-chevron-down submenu-indicator"></i>
          </a>
          <div class="submenu" v-show="openSubmenus.includes('reports')">
            <router-link to="/reports?report=StockReport&title=Stock Report" target="_blank" class="submenu-item" active-class="active">Stock Report</router-link>
            <router-link to="/reports?report=StoreReport&title=Store Report" target="_blank" class="submenu-item" active-class="active">Store Report</router-link>
            <router-link to="/param-form?report=StockReportStoreAndDateWise&title=Stock Report Date Wise" target="_blank" class="submenu-item" active-class="active">Stock Report Date Wise</router-link>
          </div>
        </div>

        <p class="menu-label mt-3" v-if="isSuperAdmin">SYSTEM ADMINISTRATION</p>
        <div class="menu-group" v-if="isSuperAdmin">
          <a class="menu-item has-submenu" @click.prevent="toggleSubmenu('sysAdmin')" :class="{ 'submenu-open': openSubmenus.includes('sysAdmin') }">
            <i class="bi bi-gear-fill"></i>
            <span>Admin</span>
            <i class="bi bi-chevron-down submenu-indicator"></i>
          </a>
          <div class="submenu" v-show="openSubmenus.includes('sysAdmin')">
            <router-link to="/companies" class="submenu-item" active-class="active" @click="closeSidebarMobile">Companies</router-link>
          </div>
        </div>
      </div>
    </aside>

    <!-- Main Content wrapper -->
    <div class="main-wrapper" :class="{ 'full-width': isLoginPage }">
      <!-- Topbar -->
      <header class="topbar" v-if="!isLoginPage" :class="{ 'transparent-topbar': !isLoginPage }">
        <div class="topbar-left">
          <button class="mobile-toggle" type="button" @click="toggleSidebar">
            <i class="bi bi-list"></i>
          </button>
        </div>
        <div id="topbar-center" class="position-absolute start-50 translate-middle-x text-center w-100"></div>

        <div class="topbar-right">
          <div class="dropdown">
            <button class="profile-btn dropdown-toggle" type="button" id="profileDropdown" data-bs-toggle="dropdown" aria-expanded="false">
              <div class="avatar">
                <i class="bi bi-person-fill"></i>
              </div>
              <span class="d-none d-md-inline ms-2">Account</span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0" aria-labelledby="profileDropdown">
              <li>
                <router-link to="/profile" class="dropdown-item">
                  <i class="bi bi-person me-2"></i> User Profile
                </router-link>
              </li>
              <li>
                <router-link to="/change-password" class="dropdown-item">
                  <i class="bi bi-shield-lock me-2"></i> Change Password
                </router-link>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item text-danger" href="#" @click.prevent="logOut">
                  <i class="bi bi-box-arrow-right me-2"></i> LogOut
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>

        <main class="content-area">
          <div class="content-container">
            <router-view></router-view>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import {AdvancedImage} from "@cloudinary/vue";
import {getCloudinaryImage} from "@/util/cloudinaryUtils";
import {mapState} from "vuex";
import {DEFAULT_COMPANY_LOGO} from "@/util/constants";

export default {
  name: "App",
  components: {
    AdvancedImage,
    Loader,
  },
  data() {
    return {
      isSidebarOpen: false,
      openSubmenus: [],
      defaultLogo: DEFAULT_COMPANY_LOGO,
    };
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/login';
    },
    ...mapState('auth', ['user']),
    tenantCloudinaryImage() {
      const path = this.user?.company?.imagePath || this.user?.imagePath;

      if (path) {
        return getCloudinaryImage(path, {height: 60, crop: 'fit'});
      }
      return null;
    },
    currentUser() {
      return this.$store?.state?.auth?.user || null;
    },
    isSuperAdmin() {
      return !!(
          this.currentUser &&
          this.currentUser.roles &&
          this.currentUser.roles.some(role => role.value === 'ROLE_SUPER_ADMIN')
      );
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    closeSidebarMobile() {
      if (window.innerWidth <= 992) {
        this.isSidebarOpen = false;
      }
    },
    toggleSubmenu(menu) {
      if (this.openSubmenus.includes(menu)) {
        this.openSubmenus = this.openSubmenus.filter(m => m !== menu);
      } else {
        this.openSubmenus.push(menu);
      }
    },
    async initializeCurrentUser() {
      const authorization = JSON.parse(localStorage.getItem("authorization"));

      if (!authorization || !this.$store) {
        return;
      }

      try {
        await this.$store.dispatch("auth/loadCurrentUser");
      } catch (e) {
        console.error("Failed to initialize current user", e);
      }
    },
    logOut() {
      if (!confirm("Do you want to logout?")) {
        return;
      }

      if (this.$store) {
        this.$store.dispatch("auth/logout");
      }

      this.$router.push("/login");
    }
  },
  async mounted() {
    const path = this.$route?.path || window.location.pathname;
    const itemTransRoutes = ['/raw-material-receive', '/issuance', '/processing',
      '/finish-good-receive'];
    const reportRoutes = ['/reports', '/param-form'];

    if (itemTransRoutes.some(tr => path.includes(tr))) {
      this.openSubmenus.push('itemTrans');
    } else if (reportRoutes.some(tr => path.includes(tr))) {
      this.openSubmenus.push('reports');
    } else if (path.includes('/companies')) {
      this.openSubmenus.push('sysAdmin');
    }

    await this.initializeCurrentUser();
  }
};
</script>

<style>
/* Base Styles */
:root {
  --primary-color: #4f46e5;
  --primary-hover: #4338ca;
  --bg-color: #f3f4f6;
  --sidebar-bg: rgba(17, 24, 39, 0.85); /* Semi-transparent */
  --sidebar-hover: rgba(31, 41, 55, 0.9);
  --sidebar-active: #374151;
  --text-main: #1f2937;
  --text-muted: #6b7280;
  --sidebar-text: #d1d5db;
  --sidebar-text-active: #ffffff;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

body, html {
  margin: 0;
  padding: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-color: var(--bg-color);
  color: var(--text-main);
  height: 100vh;
  overflow: hidden !important;
}

.logo-bar {
  display: flex;
  justify-content: space-between; /* Pushes logos to opposite sides */
  padding: 0 40px; /* Adds breathing room from the edges of the screen */
  align-items: center;
  height: 100px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  /* Frosted Glass */
  background-color: rgba(255, 255, 255, 0.25) !important;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);

  border-bottom: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05) !important;
  z-index: 1050 !important;
}

.first-logo, .second-logo {
  max-height: 60px;
  width: auto;
}

/* Topbar */
.topbar {
  position: sticky;
  /* Reset to 0 since the parent layout is already pushed down */
  top: 0 !important;
  height: 70px;
  min-height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 1040;

  /* Frosted Glass */
  background-color: rgba(255, 255, 255, 0.25) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.4) !important;
}
.app-layout {
  display: flex;
  /* Push the entire layout down below the 100px logo bar */
  margin-top: 100px;
  /* Fill the rest of the screen perfectly */
  height: calc(100vh - 130px);
  overflow: hidden;
  min-height: calc(100vh - 130px);
  align-items: flex-start;
}

/* Sidebar */
.sidebar {
  width: 280px;
  background-color: var(--sidebar-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: var(--sidebar-text);
  display: flex;
  flex-direction: column;

  top: 0 !important;

  /* Keeps your nice floating rounded edges */
  height: calc(100% - 20px);
  margin: 10px 0 10px 10px;

  border-radius: 16px;
  position: relative;
  transition: var(--transition);
  z-index: 1040;
  box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
}

/* Scrollbar for sidebar */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.sidebar-brand {
  min-height: 70px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 1.15rem;
  letter-spacing: -0.025em;
  white-space: nowrap;
}

.brand-link:hover {
  color: #fff;
}

.brand-icon {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.5rem;
  margin-right: 12px;
}

.sidebar-menu {
  padding: 24px 16px;
  flex: 1;
}

.menu-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
  margin-left: 16px;
  margin-top: 0;
  text-transform: uppercase;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 10px 16px;
  color: var(--sidebar-text);
  text-decoration: none;
  border-radius: 8px;
  margin-bottom: 6px;
  transition: var(--transition);
  font-weight: 500;
  cursor: pointer;
}

.menu-item:hover {
  background-color: var(--sidebar-hover);
  color: var(--sidebar-text-active);
}

.menu-item.active {
  background-color: rgba(79, 70, 229, 0.15);
  color: #818cf8;
  border-left: 4px solid #818cf8;
  padding-left: 12px;
}

.menu-item i:not(.submenu-indicator) {
  font-size: 1.1rem;
  margin-right: 0;
  width: 20px;
  text-align: left;
  opacity: 0.8;
}

.menu-item.active i:not(.submenu-indicator) {
  color: #818cf8;
  opacity: 1;
}

.submenu-indicator {
  font-size: 0.8rem;
  transition: transform 0.3s ease;
  margin-left: auto;
}

.has-submenu.submenu-open .submenu-indicator {
  transform: rotate(180deg);
}

.submenu {
  padding-left: 38px;
  margin-top: 0;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.submenu-item {
  position: relative;
  display: block;
  text-align: left;
  padding: 8px 12px;
  color: #9ca3af;
  text-decoration: none;
  font-size: 0.9rem;
  border-radius: 6px;
  transition: var(--transition);
}

.submenu-item:hover {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.05);
}

.submenu-item.active {
  color: #818cf8;
  font-weight: 600;
}

.submenu-item.active::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background-color: #818cf8;
  border-radius: 50%;
}

/* Main Content Wrapper */
.main-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow-y: visible !important;
}

.topbar-left, .topbar-right {
  display: flex;
  align-items: center;
}

.mobile-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 1.8rem; /* Slightly larger for easier touch */
  color: var(--text-main);
  cursor: pointer;
  padding: 8px; /* Increased touch area */
  margin-right: 16px;
  position: relative;
  z-index: 1100; /* Ensure it stays above other elements */
}

.page-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--text-main);
  text-align: center;
  margin: 0;
  letter-spacing: -0.025em;
  background: linear-gradient(135deg, #1f2937, #374151);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.profile-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 6px 12px;
  border-radius: 20px;
  transition: var(--transition);
  font-weight: 500;
  color: var(--text-main);
  cursor: pointer;
}

.profile-btn:hover {
  background-color: var(--bg-color);
}

.dropdown-toggle::after {
  margin-left: 8px;
  vertical-align: middle;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e0e7ff, #c7d2fe);
  color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dropdown-menu {
  border-radius: 12px !important;
  padding: 8px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  z-index: 2000 !important;
}

.dropdown-item {
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 500;
}

.dropdown-item:hover {
  background-color: var(--bg-color);
}

/* Content Area */
.content-area {
  flex: 1;
  padding: 24px;
  position: relative;
  overflow-y: visible;
}

.content-container {
  max-width: 1400px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);
  padding: 24px;
  min-height: calc(100% - 24px);
}

/* Responsiveness */
.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 990;
  backdrop-filter: blur(2px);
}

@media (max-width: 992px) {
  .sidebar {
    position: fixed;
    top: 100px !important;
    transform: translateX(-100%);
    box-shadow: none;
  }

  .sidebar.sidebar-open {
    transform: translateX(0);
    margin: 10px; /* Adjust mobile margins */
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.3);
  }

  .mobile-toggle {
    display: block;
  }

  .sidebar-overlay {
    display: block;
  }

  .content-container {
    padding: 16px;
  }
}
/* --- MOBILE RESPONSIVENESS FIXES --- */
@media (max-width: 992px) {
  /* Fix vertical scrolling on mobile */
  body, html {
    overflow: auto !important;
    height: auto !important;
  }

  .app-layout {
    height: auto !important;
    min-height: calc(100vh - 130px);
    overflow: visible !important;
  }

  /* Fix Sidebar overlapping with Topbar */
  .sidebar {
    z-index: 1050 !important; /* Forces sidebar above the topbar */
  }

  /* Ensure the dark overlay sits just below the sidebar but above everything else */
  .sidebar-overlay {
    z-index: 1040 !important;
  }
}
</style>